import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { vec4 } from "_src/libs/gl-matrix";
import { uniformType, uniformSource } from "_src/engine/constants";

import vertText from "_src/shaders/outline/outline.glslv";
import fragText from "_src/shaders/outline/outline.glslf";

export default class OutlineShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms(params);

  }

  //reimplementation
  initDirectives(params) {
    this._directives["OUTLINE_ONLY"] = params.outlineOnly !== undefined ? params.outlineOnly : true;
    this._directives["HALF_WIDTH"] = params.width !== undefined ? Math.round(params.width) : 1;
  }

  compile() {
    super.compile(vertText, fragText);
  }

  updateObjectUniformValues(object) {
    vec4.copy(this.uniforms["u_diffuse"].value, object.properties.diffuseColor);
  }

  attachUniforms() {

    const diffuseColor = vec4.fromValues(0.8, 0.8, 0.8, 1.0);
    const texelSize    = new Float32Array(2);

    this.uniforms["u_diffuse"] = new Uniform(uniformType.FLOAT4V, diffuseColor, uniformSource.OBJECT);

    this.uniforms["u_texel_size"] = new Uniform(uniformType.FLOAT2V, texelSize, uniformSource.SCENE);

    this.uniforms["u_text_stencil"] = new Uniform(uniformType.INT1, 0);

  }

  updateSceneUniformValues(scene) {
    this.uniforms["u_texel_size"].value[0] = scene.texelSize[0];
    this.uniforms["u_texel_size"].value[1] = scene.texelSize[1];
  }

}
